import { render, staticRenderFns } from "./upload1.vue?vue&type=template&id=648ed82c&scoped=true"
import script from "./upload1.vue?vue&type=script&lang=js"
export * from "./upload1.vue?vue&type=script&lang=js"
import style0 from "./upload1.vue?vue&type=style&index=0&id=648ed82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ed82c",
  null
  
)

export default component.exports